import React, { useCallback, useEffect, useState } from 'react'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { subscibeTo } from 'app/common/data-box-store'
import {
  classesListFilterSelection,
  customerTypeFilterSelection,
  defaultStudentListDataReceiver,
  defaultStudentListSelection,
  studentListFilter,
  studentListFilterSelection,
} from 'app/dataProviders/filter-items'
import { CustomerType } from 'app/dataTypes/reports/customersType'

type Props = {
  id: string
  pending: boolean
}

export const StudentListFilter = ({ id, pending }: Props) => {
  const [isClassReady, setClassReady] = useState<boolean>(false)
  const [isCustomerTypeReady, setReadyCustomerType] = useState<boolean>(false)

  const handleStudentsFilter = useCallback(() => {
    studentListFilter.addDataReceiver(defaultStudentListDataReceiver)
    studentListFilter.dataReceive()
    studentListFilter.setStatusReady()
  }, [])

  const classListHandler = useCallback(
    (data: string[]) => {
      if (data.length === 1) {
        setClassReady(true)
        handleStudentsFilter()
        return
      }
      studentListFilter.resetToDefault()
      studentListFilterSelection.resetToDefault()
      setClassReady(false)
    },
    [handleStudentsFilter],
  )

  const handleCustomerTypeFilter = useCallback((data: string[]) => {
    if (data.length === 1 && data[0] === CustomerType.Students) {
      setReadyCustomerType(true)
      return
    }
    studentListFilter.resetToDefault()
    setReadyCustomerType(false)
  }, [])

  useEffect(() => {
    const classesListUnsubsribe = subscibeTo<string[]>(
      classesListFilterSelection.id,
      classListHandler,
    )
    const customerTypeFilterUnsubsribe = subscibeTo<string[]>(
      customerTypeFilterSelection.id,
      handleCustomerTypeFilter,
    )

    return () => {
      classesListUnsubsribe()
      customerTypeFilterUnsubsribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    isClassReady &&
    isCustomerTypeReady && (
      <PlainItemsSelectorBox
        id={id}
        label="Учащиеся"
        header="Выбор учащегося"
        dataBoxData={studentListFilter}
        dataBoxSelection={studentListFilterSelection}
        pleaseSelectText="Нет данных"
        selectedAllOnEmptySelection
        defaultSelection={defaultStudentListSelection}
        disabled={pending}
      />
    )
  )
}
